import React from "react";
import { Cpu, Users, Globe2 } from "lucide-react";
import Reveal from "../common/Reveal";

const GOALS = [
  {
    icon: Cpu,
    title: "기술 내재화",
    desc: "데이터 분석과 AI 역량을 자체 기술로 고도화하여 흔들림 없는 경쟁력을 갖춥니다.",
  },
  {
    icon: Users,
    title: "고객 성공",
    desc: "생산성과 품질의 실질적인 개선으로, 고객의 성공이 곧 우리의 성과가 되게 합니다.",
  },
  {
    icon: Globe2,
    title: "글로벌 확장",
    desc: "국내 제조 현장에서 쌓은 경험을 바탕으로 해외 스마트공장 시장에 도전합니다.",
  },
];

const Vision = () => {
  return (
    <section className="bg-primary-50/40 py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mx-auto max-w-3xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wide text-accent-600">
            Our Vision
          </span>
          <h2 className="mt-3 break-keep text-3xl font-bold text-primary-900 sm:text-4xl">
            스마트 제조 생태계의 글로벌 리더
          </h2>
          <p className="mx-auto mt-5 break-keep text-base leading-relaxed text-gray-600">
            산업별로 특화된 MES 솔루션과 데이터 분석 역량을 바탕으로, 국내를
            넘어 글로벌 제조 현장에서 신뢰받는 스마트 제조 생태계의 중심이
            되겠습니다.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-3">
          {GOALS.map(({ icon: Icon, title, desc }, index) => (
            <Reveal key={title} delay={index * 100}>
              <div className="h-full rounded-xl bg-white p-6 shadow-sm ring-1 ring-primary-100">
                <div className="inline-flex items-center justify-center rounded-lg bg-primary-50 p-3">
                  <Icon className="h-6 w-6 text-primary-700" strokeWidth={1.75} />
                </div>
                <h3 className="mt-4 break-keep text-lg font-semibold text-primary-900">
                  {title}
                </h3>
                <p className="mt-2 break-keep text-sm leading-relaxed text-gray-600">
                  {desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Vision;
